import React from 'react'
import SmartNavigator from '../generic/SmartNavigator'
import SensorsActuators from '../configuration/Sensor&Actuators/SensorsActuators'
import SensorsActuatorsComponents from '../configuration/Sensor&Actuators/SensorsActuatorsComponents'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'

export default function MainSensorsActuators (props) {
  const activePath = props.activePath
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('SENSORS & ACTUATORS'),
      component: <SensorsActuators />,
      to: '/configuration/sensorsActuators',
      permissionCode: 'SENSORS & ACTUATORS TAB'
    },
    {
      title: t_('SENSORS & ACTUATORS COMPONENTS'),
      component: <SensorsActuatorsComponents />,
      to: '/configuration/sensorsActuatorsComponents',
      permissionCode: 'SENSOR & ACTUATOR COMPONENT'
    }

  ]

  return <SmartNavigator componentsInfo={componentsInfo} selected={activePath} />
}
